import { IKnmExecutionType } from 'APIPackage/CatalogsModule/interfaces/IKnmExecutionType';

export const createKnmExecutionTypeSelectOption = (knmExecutionType: IKnmExecutionType) => ({
  ...knmExecutionType,
  label: knmExecutionType.name,
  value: knmExecutionType.code,
});
